import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {MdbTableDirective, MdbTablePaginationComponent} from 'angular-bootstrap-md';
import { UsersService } from '../services/users.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

export interface Events {
    name: string;
    email: string;
    role: string; 

  }
@Component({
  selector: 'app-adminmanagement',
  templateUrl: './adminmanagement.component.html',
  styleUrls: ['./adminmanagement.component.scss']
})
export class AdminmanagementComponent implements OnInit {

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;
  events: any = [
    {name: 'test1', email: 'Hydrogen@hydrogen', role: 'admin'},
    {name: 'test2', email: 'Hydrogen@nitrogen', role: 'super admin'},
    {name: 'test3', email: 'Hydrogen', role: 'super admin'},
    {name: 'test4', email: 'Hydrogen', role: 'admin'},
    {name: 'test5', email: 'Hydrogen', role: 'admin'},

   
  ];
  headElements = ['Name', 'Email', 'Role', 'Action'];
  searchText: string = '';
  previous: string;

  adminsList:any = [];

  adminsForm: FormGroup


  constructor(private cdRef: ChangeDetectorRef, private usersService: UsersService, private formBuilder: FormBuilder) {
  }

  @HostListener('input') oninput() {
      this.searchItems();
  }

  ngOnInit() {
    this.adminsForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
      user_type: ['', Validators.required]
    });

      
      this.usersService.getUsersList("admin").then((res: any) => {
        if (res.success) {
          console.log(res)
          for (let i = 0; i < res.users.data.length; i++) {
             if (res.users.data[i].user_type == 2) {
              this.adminsList.push({ user_type: "admin", 
              id: res.users.data[i].id, 
              first_name: res.users.data[i].first_name,
              last_name: res.users.data[i].last_name,
              email: res.users.data[i].email,})}
              
            if (res.users.data[i].user_type == 1) {
              this.adminsList.push({ user_type: "super admin", 
              id: res.users.data[i].id, 
              first_name: res.users.data[i].first_name,
              last_name: res.users.data[i].last_name,
              email: res.users.data[i].email,})}


          console.log(this.adminsList)
          this.mdbTable.setDataSource(this.adminsList);
      this.previous = this.mdbTable.getDataSource();
        }}
        })
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
      const prev = this.mdbTable.getDataSource();
      if (!this.searchText) {
          this.mdbTable.setDataSource(this.previous);
          this.adminsList = this.mdbTable.getDataSource();
      }
      if (this.searchText) {
          this.adminsList = this.mdbTable.searchLocalDataBy(this.searchText);
          this.mdbTable.setDataSource(prev);
      }
  }

  submitForm(){
    console.log(this.adminsForm.value)
    this.usersService.addAdmin(this.adminsForm.value).then((res: any) => {
      if (res.success) {
     console.log(res)
     alert(res.message)
    }
     else alert(res.error)
  })
  }

  deactivateAdmin(id){
    console.log(id)
    this.usersService.deactivate(id).then((res: any) => {
      console.log(res)
   }) 
  }
}
